import { render, staticRenderFns } from "./myInquiry.vue?vue&type=template&id=45972950&scoped=true"
import script from "./myInquiry.vue?vue&type=script&lang=js"
export * from "./myInquiry.vue?vue&type=script&lang=js"
import style0 from "./myInquiry.vue?vue&type=style&index=0&id=45972950&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45972950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45972950')) {
      api.createRecord('45972950', component.options)
    } else {
      api.reload('45972950', component.options)
    }
    module.hot.accept("./myInquiry.vue?vue&type=template&id=45972950&scoped=true", function () {
      api.rerender('45972950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/inquiry/myInquiry.vue"
export default component.exports